// Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-center text-sm py-4 mt-10 border-t">
      <div className="space-x-4">
        <Link to="/about" className="text-blue-600 hover:underline">About Us</Link>
        <Link to="/terms-condition" className="text-blue-600 hover:underline">Terms & Conditions</Link>
        <Link to="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</Link>
      </div>
    </footer>
  );
};

export default Footer;